import React from "react";

const ThankYou = () => {
  return (
    <>
      <div className="flex flex-col justify-center my-8">
        <p className="font-bold text-gray-600 text-xl my-4 pb-2">THANK YOU</p>
        <p className="font-bold text-3xl mt-2 mb-10">Approval Pending</p>
        <p className="">
          We are reviewing your application and <br /> will get back shortly.
        </p>
      </div>
      <div>
        <button className="btn text-xl bg-black text-white py-3 px-16">
          Learn More
        </button>
        <p className="my-10">
          Have any questions?{" "}
          <a
            style={{ color: "turquoise" }}
            className=""
            href="https://tomocredit.com/dashboard/support"
          >
            Contact us
          </a>
        </p>
      </div>
    </>
  );
};

export default ThankYou;
